import { Form, Pagination } from 'react-bootstrap';
import { ResponsePaginationTable } from '@models/response-pagination-table.model';
import { useState } from 'react';

type Parameters={
    page: number,
    size: number,
    sort: string
}

export default function PaginationComponent(props: { data: ResponsePaginationTable, func: Function, obj: Parameters}) {
    
    const { first, last, number, pageable, totalPages } = props.data
    const [currentPage, setCurrentPage] = useState(pageable?.pageNumber)

    function generalNavigation(page: number){
        const objectPagination = {...props.obj }
        objectPagination.page = page
        setCurrentPage(page)
        props.func(objectPagination)
    }

    function pageSizeChoice(size: number){
        const obj =  {...props.obj }
        obj.page = 0
        obj.size = size
        setCurrentPage(0)
        props.func(obj)
    }
    return (<>
        {first && last ?
            <Pagination className='mb-0'>
                <Pagination.Prev disabled={true} />
                <Pagination.Item>{1}</Pagination.Item>
                <Pagination.Next disabled={true} />
            </Pagination>
            :
            <Pagination className='d-flex flex-row justify-content-evenly mb-0'>
                <div className='d-flex flex-row '>
                    {((currentPage ?? 0) + 1) <= 1 ? (
                        <Pagination.Prev disabled={true} />
                    ) : (
                        <Pagination.Prev onClick={()=>generalNavigation((currentPage ?? 1)-1)}/>
                    )}

                    <Pagination.Item onClick={()=>generalNavigation(0)}>{1}</Pagination.Item>

                    {((currentPage ?? 0) + 1) <= 2 ? (
                        <></>
                    ) : (
                        <Pagination.Ellipsis />
                    )}

                    {(
                        (currentPage ?? 0) + 1) <= 1 || 
                        ((currentPage ?? 0) + 1) >= (totalPages ?? 1) ?
                        <></> :
                        <Pagination.Item onClick={()=>generalNavigation((currentPage ?? 1)-1)}>{(currentPage ?? 0) + 1}</Pagination.Item>
                    }

                    {((currentPage ?? 0) + 2) >= (totalPages ?? 1) ? (
                        <></>
                    ) : (
                        <Pagination.Ellipsis />
                    )}

                    {/* <Pagination.Item onClick={()=>generalNavigation((totalPages ?? 1)-1)}>{(totalPages ?? 1) + 1}</Pagination.Item> */}
                    <Pagination.Item onClick={()=>generalNavigation((totalPages ?? 1)-1)}>{totalPages}</Pagination.Item>
                    
                    {((currentPage ?? 0) + 1) >= (totalPages ?? 1) ? (
                        <Pagination.Next disabled={true} />
                    ) : (
                        <Pagination.Next onClick={()=>generalNavigation((currentPage ?? 1)+1)}/>
                    )}
                </div>
                <Form.Select className="w-25 " name="page-size" id="page-size" onChange={(event)=>pageSizeChoice(parseInt(event.currentTarget.value))}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                </Form.Select>
            </Pagination>
            
        }</>
    );
}
